export default __webpack_public_path__ + "static/media/tutorial-step-1.b1f09d5a.png";